<template>
  <div class="popUpWrap">
    <section class="popup dark basic" style="max-width: 480px;">
      <div class="topArea">
        <div class="exit" @click.stop="dialogStore.close"></div>
      </div>
      <div class="scrollY">
        <div class="textArea">
          <h5>{{ t('organization-leave-title') }}</h5>
          <p>
            <span class="red">
              {{ t('organization-leave-info-1', { OrganizationName: dialogStore.options.props.orgName ?? '-' }) }}
            </span>
            <br>
            {{ t('organization-leave-info-2-prefix') }}
            '<span>{{ t('organization-leave') }}</span>'
            {{ t('organization-leave-info-2-suffix') }}
          </p>
        </div>
        <input type="text" :placeholder="t('organization-leave')" v-model="confirmText">
        <div class="btnArea">
          <button type="button" class="cancel" @click.stop="dialogStore.close">
            {{ t('common-cancel') }}
          </button>
          <button type="button" :disabled="isDisableLeave" :class="{ disabled: isDisableLeave }" @click.stop="onClickLeaveButton">
            {{ t('organization-leave-button') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const dialogStore = useDialogStore();

const confirmText = ref('');

const isDisableLeave = computed(() => {
  return confirmText.value !== t('organization-leave');
})

const onClickLeaveButton = () => {
  if(isDisableLeave.value) return;
  dialogStore.options.confirm?.event();
  dialogStore.close();
}
</script>